module.exports = __webpack_public_path__ + "static/media/exclamation-sign-in-a-circle.81c8f3bb.svg";